import React from 'react';

export const EXCHANGES = {
  ALL: 1,
  HOSE: 2,
  HNX: 3,
  UPCOM: 4,
};

export const mapExchange = {
  [EXCHANGES.ALL]: 'All',
  [EXCHANGES.HOSE]: 'HOSE',
  [EXCHANGES.HNX]: 'HNX',
  [EXCHANGES.UPCOM]: 'UPCOM',
};

export const CRITERIAS = {
  BUY_VALUE: 1,
  SELL_VALUE: 2,
  BUY_VOL: 3,
  SELL_VOL: 4,
  VOLUME: 5,
  VALUE: 6,
  MARKET_CAP: 7,
};

export const mapCriteria = {
  [CRITERIAS.MARKET_CAP]: 'MarketCap',
  [CRITERIAS.VOLUME]: 'Volume',
  [CRITERIAS.VALUE]: 'Value',
  [CRITERIAS.BUY_VOL]: 'FrBuyVol',
  [CRITERIAS.SELL_VOL]: 'FrSellVol',
  [CRITERIAS.BUY_VALUE]: 'FrBuyVal',
  [CRITERIAS.SELL_VALUE]: 'FrSellVal',
};

export const CurrentCriteriaContext = React.createContext(CRITERIAS.MARKET_CAP);

export const withCriteria = Component => props => {
  return (
    <CurrentCriteriaContext.Consumer>
      {criteria => <Component {...props} criteria={criteria} />}
    </CurrentCriteriaContext.Consumer>
  );
};
